// Globals
import { useTranslation } from 'react-i18next';

// Modules
import { usePermissions, Permission, Resource } from '@/modules/Permissions';

// Components
import { StyledWrapper } from '../Styled';
import { Table } from '@/ui';
import { Pagination } from '@/components';
import { UsersFiltersContainer } from '../../containers';

// Models
import { IUserProfile } from '@/models/users.model';

// helpers
import { getUsersTableColumns } from './columns';

type TUsersList = {
  usersList: IUserProfile[];
  currentPage: number;
  total: number;
  onPageChange: (page: number) => void;
  authAsUser: (id: string) => void;
  setCurrentUserDetails: (user: IUserProfile) => void;
};

const UsersList = ({ usersList, authAsUser, currentPage, total, onPageChange, setCurrentUserDetails }: TUsersList) => {
  const { t } = useTranslation(['usersList']);
  const { can, canManage } = usePermissions();
  const canViewContacts = can(Permission.SITE_USER_VIEW_CONTACTS);

  return (
    <StyledWrapper>
      <Table
        columns={getUsersTableColumns({
          t,
          setCurrentUserDetails,
          authAsUser,
          canViewContacts,
          canManage: canManage(Resource.SITE_USER),
        })}
        dataSource={usersList}
        components={{
          header: {
            wrapper: UsersFiltersContainer,
          },
        }}
      />
      <Pagination current={currentPage} total={total} onChange={onPageChange} />
    </StyledWrapper>
  );
};

export default UsersList;
